import Const from 'constants';

let PlayersExclusion = {
    setExcludedPlayersFromStorage(items) {
        return (dispatch) => {
            dispatch(this.setExcludedPlayers(items, {countPlayers: false, saveToStorage: false}));
        };
    },

    setExcludedPlayers(items, options = {}) {
        return (dispatch) => {
            const {countPlayers = true, saveToStorage = true} = options;

            dispatch({
                type: Const.EXCLUSION_SET_PLAYERS,
                items,
            });

            countPlayers && dispatch(this.setPlayersCounters());

            saveToStorage && dispatch(
                this.saveDataToStorage('filterExcluded', function (state) {
                    const {playersExclusion} = state;
                    return playersExclusion.all();
                }),
            );
        };
    },
};

export default PlayersExclusion;
